export default "__VITE_ASSET__CxrWDvvi__"